// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";

@autoinject
export class SettingsModal<TModule> implements IModal<SettingsModalState<TModule>> {
    public belongsTo: TModule;

    activateModal(
        state: SettingsModalState<TModule>,
        modalInstance: IWorkflowModuleModalInstance<SettingsModalState<TModule>>
    ): void {
        this.belongsTo = state.belongsTo;
    }
}

export class SettingsModalState<TModule> {
    public belongsTo: TModule;
}
